import { buildUserScopePayload, getDepartmentScopeValue } from "./DepartmentMultiSelect";
import { membershipUserId } from "./membershipRules";

// Scope now belongs to the user. Company access comes from assignments[].
export const buildGroupUsersPayload = (members = []) => {
  const byUser = new Map();
  members.forEach((member) => {
    const id = membershipUserId(member);
    const key = String(id);
    const { scope, departments } = buildUserScopePayload(member);
    byUser.set(key, {
      id,
      scope,
      ...(departments ? { departments } : {}),
    });
  });
  return [...byUser.values()];
};

// Accept nested responses as well as older flat GET responses during rollout.
// A company's scope/departments belong to that membership, not the user.
export const flattenGroupUsers = (users = []) => users.flatMap((user) => {
  if (!Array.isArray(user.companies)) return [user];
  const { companies, ...details } = user;
  return companies.map((company) => ({
    ...details,
    ...company,
    id: user.id,
    user_id: user.user_id,
    company: company.company ?? company.company_name,
    scope: company.scope,
    departments: company.departments ?? [],
  }));
});

// Older responses may repeat a user across companies. Keep one editor row.
// If those scopes differ, require a fresh scope choice rather than guessing.
export const normalizeGroupMembers = (users = []) => {
  const byUser = new Map();
  const signature = (user) => JSON.stringify([
    getDepartmentScopeValue(user.scope),
    getDepartmentScopeValue(user.scope) === "additional"
      ? (user.departments ?? []).map((department) => String(department?.id ?? department)).sort()
      : [],
  ]);
  flattenGroupUsers(users).forEach((user) => {
    const key = String(membershipUserId(user));
    const previous = byUser.get(key);
    if (!previous) byUser.set(key, user);
    else if (signature(previous) !== signature(user)) {
      byUser.set(key, { ...previous, scope: "", departments: [] });
    }
  });
  return [...byUser.values()];
};
